// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__235gz","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3yln6"};